import { configureStore } from "@reduxjs/toolkit";
import configSlice from "./slice/configSlice";
import groupSlice from "./slice/groupSlice";
import projectSlice from "./slice/projectSlice";

export const store = configureStore({
  reducer: {
    configSlice,
    groupSlice,
    projectSlice
  },
});
